{
  "Currency": "Currency",
  "Back to calculation": "Back to calculation",
  "Show required transactions": "Show required transactions",
  "Recalculate": "Recalculate",
  "Required transactions": "Required transactions",
  "Save": "Save",
  "Cancel": "Cancel"
}
